if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true,
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        ).outerHTML;
        this.setAttribute("available", "");

        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer"),
        );
        const colorClassesToApply =
          this.dataset.productPageColorScheme.split(" ");
        colorClassesToApply.forEach((colorClass) => {
          document
            .querySelector("pickup-availability-drawer")
            .classList.add(colorClass);
        });

        const button = this.querySelector("button");
        if (button)
          button.addEventListener("click", (evt) => {
            document
              .querySelector("pickup-availability-drawer")
              .show(evt.target);
          });
      }
    },
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      connectedCallback() {
        const trigger = this.querySelector(".pickup-store-select__trigger");
        const optionsList = this.querySelector(".pickup-store-select__options");
        if (!trigger || !optionsList) return;

        trigger.addEventListener("click", () => {
          const isOpen = trigger.getAttribute("aria-expanded") === "true";
          if (isOpen) {
            this._closeDropdown(trigger, optionsList);
          } else {
            this._openDropdown(trigger, optionsList);
          }
        });

        optionsList
          .querySelectorAll(".pickup-store-select__option")
          .forEach((option) => {
            option.addEventListener("click", () => {
              const idx = option.dataset.index;

              trigger.querySelector(".pickup-store-select__value").textContent =
                option.textContent.trim();

              optionsList
                .querySelectorAll(".pickup-store-select__option")
                .forEach((o) => {
                  o.classList.remove("is-selected");
                  o.setAttribute("aria-selected", "false");
                });
              option.classList.add("is-selected");
              option.setAttribute("aria-selected", "true");

              this.querySelectorAll(".pickup-store-overview").forEach((el) => {
                if (el.dataset.storeIndex === idx) {
                  el.removeAttribute("hidden");
                } else {
                  el.setAttribute("hidden", "");
                }
              });

              this._closeDropdown(trigger, optionsList);
            });
          });

        this._onOutsideClick = (evt) => {
          if (
            !this.querySelector(".pickup-availability-select-wrapper").contains(
              evt.target,
            )
          ) {
            this._closeDropdown(trigger, optionsList);
          }
        };
      }

      disconnectedCallback() {
        if (this._onOutsideClick) {
          document.removeEventListener("click", this._onOutsideClick);
        }
      }

      _openDropdown(trigger, list) {
        trigger.setAttribute("aria-expanded", "true");
        list.removeAttribute("hidden");
        document.addEventListener("click", this._onOutsideClick);
      }

      _closeDropdown(trigger, list) {
        trigger.setAttribute("aria-expanded", "false");
        list.setAttribute("hidden", "");
        document.removeEventListener("click", this._onOutsideClick);
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
      }
    },
  );
}
